"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminReportTypes = void 0;
exports.getAdminReportTypes = getAdminReportTypes;
exports.getAdminReportTypesFrom = getAdminReportTypesFrom;
var AdminReportTypes;
(function (AdminReportTypes) {
    AdminReportTypes["Summary"] = "summary";
    AdminReportTypes["Student"] = "student";
    AdminReportTypes["Participation"] = "participation";
    AdminReportTypes["Standard"] = "standard";
    AdminReportTypes["Performance"] = "performance";
})(AdminReportTypes || (exports.AdminReportTypes = AdminReportTypes = {}));
function getAdminReportTypes() {
    return [
        AdminReportTypes.Summary,
        AdminReportTypes.Student,
        AdminReportTypes.Participation,
        AdminReportTypes.Standard,
        AdminReportTypes.Performance,
    ];
}
function getAdminReportTypesFrom(value) {
    return getAdminReportTypes().find(function (type) { return type === value; });
}
